import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import Accordion from 'app/components/BookElements/Accordion';
import Callout from 'app/components/BookElements/Callout';
import Carousel from 'app/components/BookElements/Carousel';
import Figure from 'app/components/BookElements/Figure';
import IFrame from 'app/components/BookElements/IFrame';
import List from 'app/components/BookElements/List';
import Media from 'app/components/BookElements/Media';
import Modal from 'app/components/BookElements/Modal';
import Picture from 'app/components/BookElements/Picture';
import Section from 'app/components/BookElements/Section';
import SectionBreak from 'app/components/BookElements/SectionBreak';
import Table from 'app/components/BookElements/Table';
import Tabs from 'app/components/BookElements/Tabs';
import Title from 'app/components/BookElements/Title';

import BookElement from 'app/api/bookElement';
import LayoutEngine from 'app/api/layoutEngine';

const layoutEngine = new LayoutEngine({
  accordion: Accordion,
  audio: Media,
  carousel: Carousel,
  critical: Callout,
  disabled: Callout,
  halt: Callout,
  figure: Figure,
  info: Callout,
  interactive: IFrame,
  list: List,
  modal: Modal,
  picture:  Picture,
  ok: Callout,
  section: Section,
  table: Table,
  tabs: Tabs,
  title: Title,
  unknown: Callout,
  video: Media,
  warning: Callout,
});

function compileLayoutData(path, content, index) {
  let data;
  if (_.isString(content)) {
    data = { type: 'paragraph', path: [...path, index] };
  } else {
    let key = _.keys(content)[0];
    key = key
      .replace(new RegExp(content[key].prefix, 'i'), '')
      .replace(new RegExp(content[key].postfix, 'i'), '');
    key = _.trim(key);
    let type = key.split(' ')[0];
    data = {
      type,
      path: [...path, index, _.keys(content)[0]],
    };
  }
  return data;
}

class Composite extends React.Component {
  render() {
    const { path, content } = this.props;
    if (BookElement.isNotSelected(path)) return null;
    return (
      <React.Fragment>
        {_.map(content, (content, index) =>
          layoutEngine.render(compileLayoutData(path, content, index))
        )}
        <SectionBreak />
      </React.Fragment>
    );
  }
}

Composite.propTypes = {
  /**
   * content path
   */
  path: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ).isRequired,
  /**
   * book elements array
   */
  content: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  ),
};
Composite.defaultProps = {
  content: [],
};

export default Composite;



// WEBPACK FOOTER //
// ./src/app/components/BookElements/Composite.js